import { render, staticRenderFns } from "./SalesOrders.vue?vue&type=template&id=3d922ccb"
import script from "./SalesOrders.vue?vue&type=script&lang=js"
export * from "./SalesOrders.vue?vue&type=script&lang=js"
import style0 from "./SalesOrders.vue?vue&type=style&index=0&id=3d922ccb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports